import React from 'react';

import { Radio as MuiRadio, radioClasses, RadioProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Checked } from './icons/Checked';
import { Unchecked } from './icons/Unchecked';

export type { RadioProps };

export const Radio: React.ComponentType<RadioProps> = styled((props) => (
  <MuiRadio icon={<Unchecked />} checkedIcon={<Checked />} {...props} />
))<RadioProps>(({ theme }) => ({
  display: 'inline-flex;',
  alignItems: 'flex-start',
  gap: '10px',
  backgroundColor: theme.palette.colors.special.nulled,
  padding: 0,
  [`&:not(.Mui-disabled):not(.Mui-checked).${radioClasses.colorPrimary} .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.special.nulled,
    strokeWidth: '2px',
    stroke: theme.palette.colors.border['neutral-primary'],
  },
  [`&:not(.Mui-disabled).Mui-checked.${radioClasses.colorPrimary} .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.special.nulled,
    strokeWidth: '2px',
    stroke: theme.palette.colors.bg['action-primary'],
  },
  [`&:not(.Mui-disabled).MuiRadio-colorDanger .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.special.nulled,
    strokeWidth: '2px',
    stroke: theme.palette.colors.border['danger-primary'],
  },
  [`&.Mui-checked.Mui-disabled .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.special.nulled,
    strokeWidth: '2px',
    stroke: theme.palette.colors.special.bg.disabled,
  },
  [`&.Mui-disabled .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.special.bg.disabled,
  },
  [`&:hover`]: {
    background: 'none',
  },
  [`&:hover.Mui-checked.${radioClasses.colorPrimary} .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.static.content['key-light'],
    stroke: theme.palette.colors['bg-active']['action-primary'],
  },
  [`&:hover.Mui-checked.MuiRadio-colorDanger .MuiSvgIcon-root`]: {
    fill: theme.palette.colors.static.content['key-light'],
    stroke: theme.palette.colors['bg-active']['action-danger'],
  },
}));
